import { render, staticRenderFns } from "./ParkingDetail.vue?vue&type=template&id=fb5784d6"
import script from "./ParkingDetail.vue?vue&type=script&lang=js"
export * from "./ParkingDetail.vue?vue&type=script&lang=js"
import style0 from "./ParkingDetail.vue?vue&type=style&index=0&id=fb5784d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports